module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contentsPage",
    attrs: {
      "id": "d7e98"
    }
  }, [_c('h3', {
    staticClass: "toc",
    attrs: {
      "id": "d7e99"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('a', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c1#c1"
    }
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('a', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c2#c2"
    }
  }, [_vm._v("Introduction: A Book Is Born")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('a', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c3#c3"
    }
  }, [_c('b', [_vm._v("Chapter One: The First Month")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('a', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c3#s1"
    }
  }, [_vm._v("Choosing an O.B.")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('a', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c3#s2"
    }
  }, [_vm._v("The No-No List")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('a', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c3#s3"
    }
  }, [_vm._v("Sore Boobs")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('a', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c3#s4"
    }
  }, [_vm._v("Morning, Noon, and Night Sickness")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('a', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c3#s5"
    }
  }, [_vm._v("Gas!")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('a', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c3#s6"
    }
  }, [_vm._v("Resentment Toward Your Hubby")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('a', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c3#s7"
    }
  }, [_vm._v("Tests, Tests, and More Tests")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('a', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c3#s8"
    }
  }, [_vm._v("Dreams and Other Nightmares")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('a', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c3#s9"
    }
  }, [_vm._v("To Tell or Not to Tell")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('a', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c3#s10"
    }
  }, [_vm._v("Pregnancy Math")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('a', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c3#s11"
    }
  }, [_vm._v("How to Eat for Two")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c4#c4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Two: The Second Month")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c4#s12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hell Hath No Fury Like a Woman with Child")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c4#s13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Your Superhero Nose")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c4#s14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pregnancy Junkie")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c4#s15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spotting")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c4#s16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Need to Lie Down")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c4#s17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oh My Achin' Head")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c4#s18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Urine” for Fun")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c4#s19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Miscarriage")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c4#s20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sex During the First Trimester")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c5#c5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Three: The Third Month")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c5#s21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Can't Breathe!")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c5#s22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Is My Baby Okay in There?")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c5#s23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Here I Grow Again")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c5#s24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A New Wardrobe")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c5#s25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Name Game")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c5#s26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Your Newfound Celebrity")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c5#s27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drooling")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c5#s28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Bloody Nose")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c5#s29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beware of Your Nipples")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c6#c6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Four: The Fourth Month")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c6#s30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hyperemesis")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c6#s31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sex During the Second Trimester")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c6#s32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ultrasound")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c6#s33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I'm Scared!")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c6#s34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vaginal Discharge")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c6#s35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toilet Troubles")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c6#s36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bloody Gums")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c6#s37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Genetic Testing")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c6#s38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boy or Girl?")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c7#c7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Five: The Fifth Month")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c7#s39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pains Under Your Uterus")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c7#s40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Your Cheesy Belly")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c7#s41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You're So Vein")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c7#s42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Who Asked You?")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c7#s43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Third Nipples and Other Gross Things")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c7#s44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("That's a Hormone of a Different Color")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c7#s45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Backaches")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c7#s46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sciatica")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c8#c8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Six: The Sixth Month")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c8#s47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dark Back Hair and Other Icky Things")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c8#s48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leg Cramps")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c8#s49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Belly Touching")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c8#s50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Itchy Stomach")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c8#s51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Incompetent Cervix")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c8#s52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What, Me Exercise?")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c8#s53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oops, There She Goes!")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c8#s54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pains in the Tucchus")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c9#c9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Seven: The Seventh Month")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c9#s55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Swelling Ain't Swell")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c9#s56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Temporary Insanity")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c9#s57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sex During the Third Trimester")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c9#s58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toxemia: The Pressure Is On")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c9#s59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Third-Trimester Bleeding")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c9#s60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Braxton Hicks")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c9#s61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Can't Sleep")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c9#s62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gestational Diabetes")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c9#s63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bed Rest")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c10#c10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Eight: The Eighth Month")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c10#s64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Feeling Hot, Hot, Hot")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c10#s65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yeast Infections")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c10#s66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stretched to Extremes")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c10#s67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heartburn")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c10#s68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Urine” For Even More Fun")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c10#s69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Incontinence: A Condition That's Sure to Piss You Off")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c10#s70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Numb and Number")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c10#s71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stop That Kicking!")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c10#s72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the Hell Is This Thing Coming Out?")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c10#s73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Don't Breech to Me")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c11#c11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Nine: The Ninth Month")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c11#s74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baby Shower 101")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c11#s75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nesting Instinct")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c11#s76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lamaze Class")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c11#s77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nursing Bras")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c11#s78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Decorating the Baby's Room")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c11#s79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taking a Tour of the Hospital")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c11#s80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Am I in Labor?")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c11#s81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("False Labor")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c11#s82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Start Labor")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c12#c12",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Ten: Let the Bloody Show Begin")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c12#s83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inducing")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c12#s84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Lookie Loos”")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c12#s85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Breathe Through a Contraction")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c12#s86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gimme Drugs")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c12#s87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Push with a Passion")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c12#s88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Episiotomy: Let 'er Rip")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c12#s89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The “C” Word")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c12#s90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bonding")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c12#s91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What to Do When Nature Calls")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c12#s92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lochia: Who Knew?")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c12#s93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Got Milk?")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c13#c13",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Eleven: Home, Bittersweet Home")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c13#s94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baby Blues")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c13#s95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Deal with Visitors")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c13#s96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Better Sleep for You and Your Baby")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c13#s97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baby Hygiene")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c13#s98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sex after the Last Trimester")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c13#s99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sleep Deprivation")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c13#s100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Muscle Soreness")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c13#s101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reconcilable Differences")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c13#s102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Deal with a Crying Baby")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c13#s103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Basics")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c13#s104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Third Month")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "contentsDiv"
  }, [_c('span', {
    attrs: {
      "href": "#/Kime_9781440501951_epub_c14#c14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: Resources List")]), _vm._v(" "), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-732f10e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Kime_9781440501951_epub_toc.vue
// module id = 72
// module chunks = 0